export function uppercamelcase(str: string) {
  return str
    .toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w)/g, firstLetter => {
      return firstLetter.toUpperCase();
    })
    .replace(/[-_]/g, '');
}
